var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckValidationSucess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.857117 14.6572L5.53712 20.6743C5.69504 20.8795 5.89739 21.0463 6.12897 21.1622C6.36056 21.2779 6.61537 21.3398 6.87426 21.3429C7.12899 21.3459 7.38117 21.2919 7.61248 21.1853C7.84377 21.0785 8.04837 20.9215 8.2114 20.7257L23.1428 2.65723",
    stroke: "green",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckValidationSucess);
export default __webpack_public_path__ + "static/media/check-validation-sucess.13188713251bcc47aa827dda93ea8cf2.svg";
export { ForwardRef as ReactComponent };